import React from 'react'


export default function DetailingLinks({ tenant, allDetail, userLinkHandler }) {



    return (
        <>

            <div className='row animated slideInLeft'>
                <button style={{ marginLeft: '15px', marginBottom:'20px' }} className='btn btn-primary' onClick={() => userLinkHandler('no')}>Close Links</button>

               

                <div className="col-xs-12">
                    <p><b>KYC Link :&nbsp;</b><a target='_blank' href={allDetail != null ? allDetail.userId != null ? tenant?.WEB_URL + "kyc/" + allDetail.userId : "" : ""}>{allDetail != null ? allDetail.userId != null ? tenant?.WEB_URL + "kyc/" + allDetail.userId : "" : ""}</a></p>
                </div>
                <div className="col-xs-12">
                    <p><b>KYC Signzy Link :&nbsp;</b><a target='_blank' href={allDetail != null ? allDetail.userId != null ? tenant?.WEB_URL + "kyc/Signzy/" + allDetail.userId : "" : ""}>{allDetail != null ? allDetail.userId != null ? tenant?.WEB_URL + "kyc/Signzy/" + allDetail.userId : "" : ""}</a></p>
                </div>
                <div className="col-xs-12">
                    <p><b>KYC Digitap Link :&nbsp;</b><a target='_blank' href={allDetail != null ? allDetail.userId != null ? tenant?.WEB_URL + "kycDigitap/" + allDetail.userId : "" : ""}>{allDetail != null ? allDetail.userId != null ? tenant?.WEB_URL + "kycDigitap/" + allDetail.userId : "" : ""}</a></p>
                </div>
               
            </div>


        </>
    )

}
